import { render, staticRenderFns } from "./per-acc.vue?vue&type=template&id=2c70b600&scoped=true&"
import script from "./per-acc.vue?vue&type=script&lang=js&"
export * from "./per-acc.vue?vue&type=script&lang=js&"
import style0 from "./per-acc.vue?vue&type=style&index=0&id=2c70b600&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c70b600",
  null
  
)

export default component.exports